module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-2-chapter-title_para-style-override-10__And__Centre_Alignment"
  }, [_c('span', [_c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007"
    }
  }, [_vm._v("Chapter 1")]), _vm._v("      Lighting the Way")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008"
    }
  }, [_vm._v("Chapter 2")]), _vm._v("      Legends of the First People")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v("      All in a Day’s Catch")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v("      Crossing the Finish Line")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v("      Beauvoir, a Complicated History")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v("      Queen of the Watering Places")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v("      The Crown Jewel")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v("      Biloxi’s Hermit")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v("      Fantasy Island")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _vm._v("    The Mad Potter")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _vm._v("    The Root Beer Wizard")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _vm._v("    Gus, Elvis, and Jayne")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _vm._v("    Keep ’em Flying")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _vm._v("    Mary’s Legacy")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _vm._v("    Motels, Eateries, and Attractions")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _vm._v("    Sand, Surf, and Struggle")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _vm._v("    Mother Nature Unleashed")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _vm._v("    Iberville, Ixolib, and Vintage Cars")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")]), _vm._v("    Place Your Bets")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")]), _vm._v("    Cultural Connections")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    attrs: {
      "href": "#/section0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0